// @flow
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import _ from 'lodash';

import * as organisationsActions from 'app/ducks/organisations/actions';
import * as organisationAddressesActions from 'app/ducks/organisationAddresses/actions';
import * as bankAccountActions from 'app/ducks/bankAccounts/actions';

import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as organisationAddressesSelectors from 'app/ducks/organisationAddresses/selectors';
import * as loadingSelectors from 'app/ducks/loading/selectors';

import SettingsLayout from './SettingsLayout';

const selector = (state) => ({
  organisations: organisationsSelectors.getOrganisations(state),
  organisationAddresses: organisationAddressesSelectors.getOrganisationAddresses(state),
  bankAccount: state.bankAccount,
  appReady: loadingSelectors.appReady(state),
});

const actionCreators = _.merge(organisationsActions, bankAccountActions, organisationAddressesActions);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)

export default class SettingsView extends React.Component {
  static propTypes = {
    actions: PropTypes.object,
    organisations: PropTypes.object,
    organisationAddresses: PropTypes.object,
    bankAccount: PropTypes.object,
    appReady: PropTypes.bool,
  };

  static defaultProps = {
    actions: undefined,
    organisations: undefined,
    organisationAddresses: undefined,
    bankAccount: undefined,
    appReady: false,
  };

  render(): React.ReactNode {
    return <SettingsLayout {...this.props} />;
  }
}
